var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1953 11.8984L10.1484 8.85156C10.834 7.83594 11.1895 6.56641 11.0117 5.19531C10.6816 2.85938 8.77734 0.980469 6.4668 0.675781C3.01367 0.244141 0.09375 3.16406 0.525391 6.61719C0.830078 8.92773 2.70898 10.832 5.04492 11.1621C6.41602 11.3398 7.68555 10.9844 8.72656 10.2988L11.748 13.3457C12.1543 13.7266 12.7891 13.7266 13.1953 13.3457C13.5762 12.9395 13.5762 12.3047 13.1953 11.8984ZM2.50586 5.90625C2.50586 4.12891 3.95312 2.65625 5.75586 2.65625C7.5332 2.65625 9.00586 4.12891 9.00586 5.90625C9.00586 7.70898 7.5332 9.15625 5.75586 9.15625C3.95312 9.15625 2.50586 7.70898 2.50586 5.90625Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.62b78549d255b87b11a49688b7f52067.svg";
export { ForwardRef as ReactComponent };